<div class="sm-flex sm-flex-col sm-gap-y-2">
  <div class="sm-flex sm-flex-col sm-gap-y-2">
    <span>List source:</span>
    <div data-test="list-name" class="sm-w-full sm-rounded sm-bg-grey-1 sm-border-2 sm-border-grey-3 sm-p-2">
      {{ listName }}
    </div>
  </div>
  <div data-test="column-name" class="sm-flex sm-flex-col sm-gap-y-2">
    <span>Referenced Column:</span>
    <div class="sm-w-full sm-rounded sm-bg-grey-1 sm-border-2 sm-border-grey-3 sm-p-2">
      {{ referenceColumn.heading }}
    </div>
  </div>
  <div class="sm-flex sm-flex-col sm-gap-y-2">
    <span>List Property:</span>
    <ng-select
      [(ngModel)]="cellData.content.propertyId"
      appendTo="body"
      placeholder="Select list property"
      i18n-placeholder="Select list property"
    >
      <ng-option *ngFor="let property of listProperties" [value]="property._id">
        <span>{{ property.name }}</span>
      </ng-option>
    </ng-select>
    <a
      href="https://app.intercom.com/a/apps/mif72555/articles/articles/9120893/show"
      target="_blank"
      class="button-learn-more"
    >
      <em class="cc-icon cc-icon-question" aria-hidden="true"></em>
      <span i18n>Learn more </span>
    </a>
  </div>
</div>
